<form
  name="couponForm"
  class="co-form-address"
  [ngClass]="{
    'co-form-coupon--skl': env === 'skl',
    'co-form-coupon--nkl': env === 'nkl'
  }"
  *ngIf="!hideCouponForm"
  (ngSubmit)="submitCoupon(false)"
  [formGroup]="couponForm"
  novalidate
>
  <h2 class="uk-h3" *ngIf="!hideCouponForm">
    Gutscheine und Rabattcodes (Optional)
  </h2>
  <div class="co-form-group co-form-group--coupon clearfix row">
    <div class="uk-margin-small">
      <div class="small-12 medium-3 columns">
        <label for="" class="middle">Gutscheincode</label>
      </div>
      <div class="small-12 medium-9 columns">
        <div class="clearfix">
          <i
            class="co-form-remove-icon"
            *ngIf="couponFieldIsfilled"
            (click)="emptyCouponField()"
          >
            <svg viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </i>
          <input
            type="text"
            class="co-form-input co-form-input--coupon uk-input"
            formControlName="couponCode"
            #couponInput
          />
          <button
            class="uk-form-width-medium uk-button uk-margin-small-top uk-margin-remove"
            *ngIf="couponFieldIsfilled"
            [disabled]="couponForm.invalid"
          >
            Einlösen
          </button>
        </div>
        <div class="co-coupon-response error" *ngIf="errorMessage?.length">
          <i class="co-icon">
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
              />
            </svg>
          </i>
          <p *ngFor="let msg of errorMessage">{{ msg }}</p>
        </div>
        <div class="co-coupon-response success" *ngIf="couponConfirmation">
          <i class="co-icon">
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
              />
            </svg>
          </i>
          Der Gutscheincode {{ couponConfirmation.code }} wurde erfolgreich
          eingelöst.
        </div>
      </div>
    </div>
  </div>
</form>
